import keys from 'lodash/keys';

export const makeFormFile = (file, rest = {}) => {
  const data = new FormData();
  data.append('file', file);
  keys(rest).forEach((key) => data.append(key, rest[key]));
  return data;
};
